export enum TraversalOrder {
  PreOrder,
  InOrder,
  PostOrder,
  LevelOrder,
}